export default "__VITE_ASSET__C7rH$uuv__"